import service from "@/store/services/unit-of-measures-service";

export const state = () => ({
  list: {},
  unitOfMeasure: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, unitOfMeasure) => {
    state.unitOfMeasure = unitOfMeasure;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((unitOfMeasure) => {
      commit("SET_RESOURCE", unitOfMeasure);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((unitOfMeasure) => {
      commit("SET_RESOURCE", unitOfMeasure);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((unitOfMeasure) => {
      commit("SET_RESOURCE", unitOfMeasure);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  unitOfMeasure: (state) => state.unitOfMeasure,
  url: (state) => state.url,
};

const unitOfMeasures = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default unitOfMeasures;
